import { render } from "./PurchaseEvent.vue?vue&type=template&id=64028552&scoped=true"
import script from "./PurchaseEvent.vue?vue&type=script&lang=js"
export * from "./PurchaseEvent.vue?vue&type=script&lang=js"

import "./PurchaseEvent.vue?vue&type=style&index=0&id=64028552&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64028552"]])

export default __exports__